(function () {
  var LOCALE_COOKIE = 'suave_locale_pref';
  var LEGACY_COMPARISON_LANG_KEY = 'suave-comparison-language';

  function normRoot(root) {
    root = String(root || '/').replace(/\/+$/, '');
    return root === '' ? '/' : root;
  }

  function getLocalePref() {
    var match = document.cookie.match(/(?:^|; )suave_locale_pref=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setLocalePref(code) {
    document.cookie =
      LOCALE_COOKIE + '=' + encodeURIComponent(code) + '; path=/; max-age=31536000; SameSite=Lax';
  }

  function stripLocalePrefix(path) {
    var es = '/es';
    var en = '/en';
    if (path === es || path.indexOf(es + '/') === 0) {
      return path.slice(es.length) || '/';
    }
    if (path === en || path.indexOf(en + '/') === 0) {
      return path.slice(en.length) || '/';
    }
    return path.replace(/^\/(es|en)(?=\/|$)/, '') || '/';
  }

  function buildLocaleUrl(localeCode) {
    var path = window.location.pathname || '/';
    var search = window.location.search || '';
    var hash = window.location.hash || '';
    var stripped = stripLocalePrefix(path);
    if (stripped === '/') stripped = '';

    if (String(localeCode).toLowerCase() === 'en') {
      return (stripped || '/') + search + hash;
    }

    return normRoot('/es') + stripped + search + hash;
  }

  function getLocalizationForm(code) {
    var id = code === 'es' ? 'SuaveLocaleSwitchEs' : 'SuaveLocaleSwitchEn';
    return document.getElementById(id);
  }

  var SCROLL_KEY = 'suave_locale_scroll_y';

  function saveScrollPosition() {
    try {
      sessionStorage.setItem(
        SCROLL_KEY,
        String(window.scrollY || window.pageYOffset || 0)
      );
    } catch (e) {}
  }

  function restoreScrollPosition() {
    var raw;
    try {
      raw = sessionStorage.getItem(SCROLL_KEY);
      sessionStorage.removeItem(SCROLL_KEY);
    } catch (e) {
      return;
    }
    if (raw == null || raw === '') return;
    var y = parseInt(raw, 10);
    if (!isFinite(y) || y < 0) return;
    var apply = function () {
      window.scrollTo(0, y);
    };
    apply();
    requestAnimationFrame(apply);
    setTimeout(apply, 50);
    setTimeout(apply, 200);
  }

  function switchLocale(localeCode) {
    if (!localeCode) return;
    var code = String(localeCode).toLowerCase() === 'en' ? 'en' : 'es';
    setLocalePref(code);
    saveScrollPosition();

    try {
      document.dispatchEvent(
        new CustomEvent('suave:localechange', { detail: { code: code } })
      );
    } catch (e) {}

    syncAllLocalizedCopy(code);

    // Prefer Shopify localization form so Translate & Adapt / Markets locale activates.
    var form = getLocalizationForm(code);
    if (form) {
      var returnInput = form.querySelector('[name="return_to"]');
      if (returnInput) {
        returnInput.value = buildLocaleUrl(code);
      }
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
      return;
    }

    window.location.assign(buildLocaleUrl(code));
  }

  function isSiteSpanish() {
    var path = window.location.pathname || '';
    if (path === '/es' || path.indexOf('/es/') === 0) return true;
    if (path === '/en' || path.indexOf('/en/') === 0) return false;
    var rootEl = document.documentElement;
    var dataLocale = rootEl && rootEl.getAttribute('data-suave-locale');
    if (dataLocale === 'es') return true;
    if (dataLocale === 'en') return false;
    var htmlLang = (rootEl && rootEl.getAttribute('lang')) || '';
    if (String(htmlLang).toLowerCase().indexOf('es') === 0) return true;
    return false;
  }

  function getCurrentLocaleCode() {
    return isSiteSpanish() ? 'es' : 'en';
  }

  function pickAttr(el, primary, fallback) {
    var preferred = el.getAttribute(primary);
    if (preferred != null && String(preferred).trim() !== '') return preferred;
    var other = el.getAttribute(fallback);
    if (other != null && String(other).trim() !== '') return other;
    return preferred != null ? preferred : other;
  }

  function syncI18nLabels(code) {
    var locale = code === 'es' ? 'es' : 'en';
    document.querySelectorAll('[data-suave-i18n]').forEach(function (el) {
      var text = pickAttr(el, 'data-suave-lang-' + locale, 'data-suave-lang-' + (locale === 'es' ? 'en' : 'es'));
      if (text != null) el.textContent = text;
    });
  }

  function syncDataEsEn(code) {
    var locale = code === 'es' ? 'es' : 'en';
    document.querySelectorAll('[data-es][data-en]').forEach(function (el) {
      if (el.classList && el.classList.contains('suave-component-label')) return;
      var text = pickAttr(el, 'data-' + locale, 'data-' + (locale === 'es' ? 'en' : 'es'));
      if (text != null) el.textContent = text;
    });
  }

  function syncAllLocalizedCopy(code) {
    var locale = code === 'es' || code === 'en' ? code : getCurrentLocaleCode();
    syncI18nLabels(locale);
    syncDataEsEn(locale);
  }

  function positionLanguageThumb(switchEl) {
    if (!switchEl) return;
    var thumb = switchEl.querySelector('.suave-language-switch__thumb');
    var active = switchEl.querySelector('.suave-language-switch__option.is-active');
    if (!thumb || !active) return;
    var sRect = switchEl.getBoundingClientRect();
    var aRect = active.getBoundingClientRect();
    /* Vertical inset is CSS (top/bottom: 3px); only slide horizontally so padding stays even. */
    var x = aRect.left - sRect.left;
    thumb.style.height = '';
    thumb.style.width = Math.max(0, aRect.width) + 'px';
    thumb.style.transform = 'translateX(' + x + 'px)';
  }

  function positionAllLanguageThumbs() {
    document.querySelectorAll('.suave-language-switch').forEach(positionLanguageThumb);
  }

  function setLanguageSwitchActive(switchEl, code) {
    if (!switchEl) return;
    switchEl.setAttribute('data-active', code);
    switchEl.querySelectorAll('[data-suave-locale-code]').forEach(function (option) {
      var isActive = option.getAttribute('data-suave-locale-code') === code;
      option.classList.toggle('is-active', isActive);
      if (isActive) option.setAttribute('aria-current', 'true');
      else option.removeAttribute('aria-current');
    });
    positionLanguageThumb(switchEl);
  }

  function syncLanguageSwitchState() {
    var currentCode = getCurrentLocaleCode();

    document.querySelectorAll('.suave-language-switch').forEach(function (switchEl) {
      setLanguageSwitchActive(switchEl, currentCode);
    });

    syncAllLocalizedCopy(currentCode);
  }

  function detectLocaleCode(value) {
    if (!value) return 'en';
    var path = String(value);
    try {
      if (path.indexOf('://') !== -1) {
        path = new URL(path).pathname || '/';
      }
    } catch (e) {}
    if (path === '/es' || path.indexOf('/es/') === 0) return 'es';
    if (/\/es(\/|$)/.test(path)) return 'es';
    return 'en';
  }

  function bindFooterSelects() {
    document.querySelectorAll('[data-suave-footer-lang-select]').forEach(function (select) {
      if (select.dataset.suaveFooterLangBound === '1') return;
      select.dataset.suaveFooterLangBound = '1';
      select.addEventListener('change', function () {
        var selected = select.options[select.selectedIndex];
        var code =
          (selected && selected.getAttribute('data-suave-locale-code')) ||
          detectLocaleCode(select.value);
        switchLocale(code);
      });
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var localeLink = event.target.closest('[data-suave-locale-code]');
      if (!localeLink) return;

      event.preventDefault();
      event.stopPropagation();

      var code = localeLink.getAttribute('data-suave-locale-code');
      if (code === getCurrentLocaleCode()) return;

      var switchEl = localeLink.closest('.suave-language-switch');
      setLanguageSwitchActive(switchEl, code);

      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !switchEl) {
        switchLocale(code);
        return;
      }
      window.setTimeout(function () {
        switchLocale(code);
      }, 300);
    },
    true
  );

  function syncCookieToPathLocale() {
    var path = window.location.pathname || '';
    if (path === '/es' || path.indexOf('/es/') === 0) {
      setLocalePref('es');
    } else if (path === '/en' || path.indexOf('/en/') === 0) {
      setLocalePref('en');
    }
  }

  function clearLegacyLocaleState() {
    try {
      localStorage.removeItem(LEGACY_COMPARISON_LANG_KEY);
    } catch (e) {}
  }

  window.SuaveLocale = {
    switchLocale: switchLocale,
    buildLocaleUrl: buildLocaleUrl,
    getLocalePref: getLocalePref,
    setLocalePref: setLocalePref,
    isSiteSpanish: isSiteSpanish,
    getCurrentLocaleCode: getCurrentLocaleCode,
    syncLanguageSwitchState: syncLanguageSwitchState,
    syncLanguagePickerLabel: syncLanguageSwitchState,
    syncI18nLabels: syncI18nLabels,
    syncAllLocalizedCopy: syncAllLocalizedCopy
  };

  function initSuaveLocale() {
    clearLegacyLocaleState();
    syncCookieToPathLocale();
    syncLanguageSwitchState();
    bindFooterSelects();
    restoreScrollPosition();
    requestAnimationFrame(function () {
      positionAllLanguageThumbs();
      requestAnimationFrame(positionAllLanguageThumbs);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSuaveLocale);
  } else {
    initSuaveLocale();
  }

  window.addEventListener('pageshow', function () {
    syncLanguageSwitchState();
    restoreScrollPosition();
    requestAnimationFrame(positionAllLanguageThumbs);
  });

  window.addEventListener('resize', function () {
    positionAllLanguageThumbs();
  }, { passive: true });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (
        !event.target.classList.contains('section-suave-footer') &&
        !event.target.classList.contains('section-suave-nav-bar') &&
        !event.target.classList.contains('section-suave-sticky-shop-bar') &&
        !event.target.classList.contains('suave-comparison-section')
      ) {
        return;
      }

      document.querySelectorAll('.section-suave-footer [data-suave-footer-lang-select]').forEach(function (select) {
        delete select.dataset.suaveFooterLangBound;
      });
      initSuaveLocale();
    });
  }
})();
